import { jsx as _jsx } from "react/jsx-runtime";
import { Modal, Table } from "antd";
import { DownloadDocument, formatDisplayDate } from "../../utils/commonUtil";
const SubProjectCertificateModal = ({ isModalOpen, handleOk, handleCancel, modalContent, title }) => {
    const handleDownloadCertificate = (strDocRefId) => {
        // const objEEDocument: EEDocument = {
        //   strDocRefId: strDocRefId,
        //   strAction: "CERT",
        // }
        // getDocument(objEEDocument);
        DownloadDocument(strDocRefId);
    };
    // function getDocument(objEEDocument: EEDocument) {
    //   getCertificateDocument(objEEDocument).then((responseData: any) => {
    //     let typeOfFile = {};
    //     if (responseData?.strDocName?.includes('.pdf')) {
    //       typeOfFile = { type: 'application/pdf' };
    //     } else {
    //       typeOfFile = { type: 'octet-stream' };
    //     }
    //     //Convert the bytefileData to a Blob
    //     const blob = new Blob([new Uint8Array(responseData?.bytefileData)], typeOfFile);
    //     // Create a download link for the Blob
    //     //for print preview use the following
    //     const downloadUrl = window.URL.createObjectURL(blob);
    //     window.open(downloadUrl);
    //   });
    // }
    const columns = [
        {
            title: 'Certificate Name',
            dataIndex: 'certificateName',
            key: 'certificateName',
            render: (text, params) => (_jsx("span", { style: { textWrap: 'wrap', textDecoration: 'underline', color: 'blue', cursor: 'pointer' }, onClick: (e) => handleDownloadCertificate(params === null || params === void 0 ? void 0 : params.strDocRefId), children: params.certificateName }))
        },
        {
            title: 'Certificate Date',
            dataIndex: 'certificateDate',
            key: 'certificateDate',
        },
        {
            title: 'Certificate ID',
            dataIndex: 'certificateId',
            key: 'certificateId',
        },
        {
            title: 'Certificate Expiration Date',
            dataIndex: 'certificateExpirationDate',
            key: 'certificateExpirationDate',
        },
    ];
    const dataSource = modalContent === null || modalContent === void 0 ? void 0 : modalContent.map((data, index) => {
        return {
            key: index,
            strDocRefId: data === null || data === void 0 ? void 0 : data.strDocRefId,
            certificateName: data === null || data === void 0 ? void 0 : data.strDocName,
            certificateDate: formatDisplayDate(data === null || data === void 0 ? void 0 : data.dtCertDate),
            certificateId: data === null || data === void 0 ? void 0 : data.strCertId,
            certificateExpirationDate: formatDisplayDate(data === null || data === void 0 ? void 0 : data.dtCertExpirationDate),
        };
    });
    return (_jsx(Modal, { title: title, open: isModalOpen, onOk: handleOk, onCancel: handleCancel, children: _jsx(Table, { columns: columns, dataSource: dataSource }) }));
};
export default SubProjectCertificateModal;
